// ----------------------------------------------------------------------

const account = {
  displayName: 'DASOL',
  email: 'info@aiodock.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
  // role: 'user',
};

export default account;
